/**
 * Where an RMS service user is sent instead of a portal page that belongs to
 * another role, or null to let them through.
 *
 * ProtectedRoute lets every signed-in user onto the non-provider /rms pages,
 * because a passwordless sign-in can land before its claims do. Once the
 * account's userType is known, each role keeps to its own portal: a class
 * teacher to their task list and the forms it opens (TDI-489), including the
 * v4 strengths and needs form when the SENCO gave it to them (TDI-618), a parent or
 * carer to the family portal, a school user to the school portal. The server
 * still decides what any of them may read or change; this only stops a page
 * from offering actions that would be refused.
 *
 * @param {string} pathname
 * @param {string} [userType] the account's userType claim
 * @returns {string|null}
 */
export function rmsServiceUserRedirect(pathname, userType) {
  const path = String(pathname || '');
  const type = String(userType || '').toLowerCase();
  if (!type || !path.startsWith('/rms')) return null;

  if (type.includes('teacher')) {
    const own = path === '/rms/teacher'
      // Their pupil's page and its answers download (TDI-620).
      || /^\/rms\/teacher\/pupils\/[^/]+(\/answers\/print)?$/.test(path)
      || /^\/rms\/patient\/[^/]+\/forms\//.test(path)
      // The v4 strengths and needs school form, its own page (TDI-525, TDI-618).
      || /^\/rms\/patient\/[^/]+\/hfp-v4$/.test(path);
    return own ? null : '/rms/teacher';
  }
  if (type.includes('guardian') && (path === '/rms/pupils' || path.startsWith('/rms/pupils/'))) {
    return '/rms/family/children';
  }
  if (type.includes('school') && path.startsWith('/rms/family/')) {
    return '/rms/pupils';
  }
  return null;
}
